import { render, staticRenderFns } from "./personInChargeModal.vue?vue&type=template&id=1181af1f&scoped=true"
import script from "./personInChargeModal.vue?vue&type=script&lang=js"
export * from "./personInChargeModal.vue?vue&type=script&lang=js"
import style0 from "./personInChargeModal.vue?vue&type=style&index=0&id=1181af1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1181af1f",
  null
  
)

export default component.exports